import type { SpecialItem } from "@/types/content";

export const specialItems: SpecialItem[] = [
  {
    id: "classic-scifi",
    title: "经典科幻电影巡礼",
    subtitle: "当宇宙成为叙事的主角",
    intro:
      "从近未来轨道站到云层之上的记忆档案，科幻从来不只是特效。这个专题挑选了六部在视觉与思辨之间取得平衡的作品，看看创作者如何用宇宙的尺度，讲人类自己的问题。",
    cover:
      "https://readdy.ai/api/search-image?query=Panoramic%20illustration%20of%20a%20retro%20futuristic%20space%20station%20interior%20with%20circular%20windows%20overlooking%20stars%2C%20deep%20navy%20and%20amber%20control%20lights%2C%20cinematic%20sci-fi%20mood%2C%20no%20text&width=1200&height=600&seq=tm-special-scifi&orientation=landscape",
    mediaIds: ["interstellar-echo", "cloud-archive", "train-number-seven"],
    reasons: [
      {
        title: "视觉为情感服务",
        text: "这些作品的共同点，是奇观从不单独存在。每一个太空舱、每一段跃迁，都对应着人物的一次选择。",
      },
      {
        title: "设定可信，问题真实",
        text: "记忆可被编辑、时间可被循环、信号来自四十年前——设定各不相同，但追问的都是同一件事：我们如何确认自己。",
      },
      {
        title: "适合深夜连看",
        text: "节奏偏慢，信息密度高，建议关灯、戴耳机，一次只看一部。",
      },
    ],
    tags: ["科幻", "思辨", "视觉系"],
  },
  {
    id: "city-suspense",
    title: "城市悬疑夜",
    subtitle: "在霓虹与雨水之间寻找真相",
    intro:
      "港口、旧楼、夜车与警署走廊，城市本身就是悬疑片最好的布景。本专题收录四部以城市空间为核心的作品，看镜头如何用街道和灯光讲故事。",
    cover:
      "https://readdy.ai/api/search-image?query=Panoramic%20night%20cityscape%20with%20rain%2C%20neon%20reflections%20on%20wet%20streets%20and%20a%20lone%20figure%20with%20umbrella%2C%20deep%20navy%20and%20warm%20orange%20highlights%2C%20cinematic%20noir%20mood%2C%20no%20text&width=1200&height=600&seq=tm-special-suspense&orientation=landscape",
    mediaIds: ["long-night-coming", "city-edge", "dark-tide-city", "train-number-seven"],
    reasons: [
      {
        title: "同一座城市，四种视角",
        text: "老刑警、拆迁户、港口刑警与被困乘客，四组人物拼出一座城市完整的夜。",
      },
      {
        title: "雨水是最勤恳的演员",
        text: "四部作品都不约而同地使用了雨夜。湿透的路面让每一盏灯都多出一个倒影。",
      },
      {
        title: "线索藏在日常里",
        text: "一盘录音带、一张搬迁通知、一段重复的广播。真相往往不在高潮，而在被忽略的细节中。",
      },
    ],
    tags: ["悬疑", "犯罪", "城市"],
  },
  {
    id: "wuxia-new-chapter",
    title: "华语武侠新章",
    subtitle: "剑还在，江湖换了模样",
    intro:
      "这一代创作者正在用自己的方式重讲武侠：少一些招式炫技，多一些人在江湖中的处境。专题收录近年最具代表性的两部作品，以及一份关于武侠影像的延伸阅读。",
    cover:
      "https://readdy.ai/api/search-image?query=Panoramic%20ink%20wash%20painting%20of%20mountain%20peaks%20and%20a%20lone%20swordswoman%20silhouette%2C%20mist%20and%20pine%20trees%2C%20muted%20blue%20gray%20with%20warm%20amber%20accent%2C%20cinematic%20oriental%20mood%2C%20no%20text&width=1200&height=600&seq=tm-special-wuxia&orientation=landscape",
    mediaIds: ["white-horse-youth", "between-mountains-seas"],
    reasons: [
      {
        title: "实景拍摄的诚意",
        text: "竹林、雪线、山脊全部实景，四十六场动作戏没有使用虚拟棚。",
      },
      {
        title: "不着急的叙事",
        text: "公路式结构，一城一遇。武戏之外，更多篇幅留给了对话与行走。",
      },
      {
        title: "东方奇幻的另一条路",
        text: "《山海之间》把神话放回山水之间，让传说重新长在土地上。",
      },
    ],
    tags: ["武侠", "古装", "东方美学"],
  },
];

